import mixin from '@/store/mixins/data-grid'

const { stateMixin, gettersMixin, mutationsMixin, actionsMixin } = mixin

const state = {
  ...stateMixin('auth:permission', 'name')
}

const getters = {
  ...gettersMixin()
}

const mutations = {
  ...mutationsMixin()
}

const actions = {
  ...actionsMixin()
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
